import { noteDown } from './noteDown.js';

const logger = noteDown;

export { logger };
